export default __webpack_public_path__ + "static/media/phone.f7253f8e.png";